import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import Tag from './Tag';

const NewPriceTag = () => {
  const { tileData } = useTileDataContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);

  return (
    <Clickable
      data-qa="new-price-badge"
      data-analytics-id="open-result-tile-modal"
      data-analytics-attributes={JSON.stringify({
        clickedSource: 'New price tag'
      })}
      className="pointer-events-auto"
      onClick={e => {
        e.preventDefault();
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.NewPrice,
          vehicle: tileData
        });
      }}
    >
      <Tag text="New Price" bgColor="bg-green-2" />
    </Clickable>
  );
};

export default NewPriceTag;
